const mapping = {
  requested: {
    title: 'Solicitados',
    icon: 'fas fa-question',
  },
  correction: {
    title: 'Em correção',
    icon: 'fas fa-edit',
  },
  corrected: {
    title: 'Corrigidos',
    icon: 'fas fa-edit',
  },
  rejected: {
    title: 'Rejeitados',
    icon: 'fas fa-thumbs-down',
  },
  screening: {
    title: 'Em triagem',
    icon: 'fas fa-stethoscope',
  },
  forwarded: {
    title: 'Encaminhados',
    icon: 'fas fa-share-square',
  },
  caught: {
    title: 'Saídas',
    icon: 'fas fa-hand-holding-medical',
  },
  hospitalized: {
    title: 'Internados',
    icon: 'fas fa-procedures',
  },
  medicalRelease: {
    title: 'Alta médica',
    icon: 'fas fa-notes-medical',
  },
  pullout: {
    title: 'Retiradas',
    icon: 'fas fa-ambulance',
  },
  done: {
    title: 'Concluídos',
    icon: 'fas fa-check',
  },
  death: {
    title: 'Óbitos',
    icon: 'fas fa-heart-broken',
  },
  canceled: {
    title: 'Cancelados',
    icon: 'fas fa-ban',
  },
  all: {
    title: 'Todos os atendimentos clínicos',
    icon: 'fas fa-stethoscope',
  },
}

export default (status) => mapping[status] || mapping.all
